import { defaultTo } from 'ramda';
import { IAutoProlongInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/AutoProlongInfoSchema';
import { IAutoProlongInfo } from '../../../types/reducers/checkoutInfo';

export function mapAutoProlongInfo(autoProlongInfo?: IAutoProlongInfoSchema | null): IAutoProlongInfo {
  const { isAvailable, hintText, tooltipText } = autoProlongInfo || {};

  return {
    isAvailable: defaultTo(false, isAvailable),
    hintText: defaultTo('', hintText),
    tooltipText: defaultTo('', tooltipText),
  };
}
